<template>
  <div class="login" id="login">
    <div class="login_con">
      <div class="login_rigth">
        <img src="../../assets/login/logo@2x.png" class="logon_logo" />
        <p class="logon_title">用户登录</p>
        <input type="text" autocomplete="off" placeholder="输入账号" class="login_user" v-model="user" @keyup.enter="submit" />
        <input
          type="password"
          placeholder="输入密码"
          class="login_user"
          v-model="pwd"
          @keyup.enter="submit"
        />
        <p class="login_btn" @click="submit">登录</p>
      </div>
    </div>
  </div>
</template>
<script>
import qs from 'qs';
import apiURL from "../../util/api";
export default {
  data() {
    return {
      user: "",
      pwd: ""
    };
  },
  metaInfo: {
    title: "千年医典数据库-科学支撑中医临床、教学科研、健康养生",
    meta: [
      { name: "keywords", content: "中医古籍登录" },
      {
        name: "description",
        content: "需要登录后,才可以阅读相关域内域外中医古籍"
      }
    ]
  },
  created() {
    this.user = this.$store.state.usernumber || null
    const hashLocation = this.$route.path;
    //   const newLocation = hashLocation.split("#/")[1];
    const url = "https://www.kanguji.com" + hashLocation;
    this.$matomo.setCustomUrl(url); //覆盖页面报告的url，可以自定义页面url，加上本页面路由
    //   this.$matomo.trackEvent(shopCode,hashLocation);//事件
    // this.$matomo.trackPageView(hashLocation);//页面名称,可以自定义页面名称
  },
  mounted() {
    if(!this.$route.params.again){
        if (typeof this.$store.state.user_id != "undefined") {
          this.$router.push({
            path: "/index"
        });
      }
    }else{
      localStorage.removeItem("user_id");
      this.$router.go(0)
    }
    var h = document.documentElement.offsetHeight || document.body.offsetHeight;
    var login = document.getElementById("login");
    var loginh = h - 100;
    login.style.height = loginh + "px";
  },
  methods: {
    IEVersion() {
      var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
      var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
      var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
      var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
      if(isIE) {
          var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
          reIE.test(userAgent);
          var fIEVersion = parseFloat(RegExp["$1"]);
          if(fIEVersion == 7) {
              return 7;
          } else if(fIEVersion == 8) {
              return 8;
          } else if(fIEVersion == 9) {
              return 9;
          } else if(fIEVersion == 10) {
              return 10;
          } else {
              return 6;//IE版本<=7
          }   
      } else if(isEdge) {
          return 'edge';//edge
      } else if(isIE11) {
          return 11; //IE11  
      }else{
          return -1;//不是ie浏览器
      }
  },
    submit() {
      var that = this;
      if (this.user == "" || this.pwd == "") {
        alert("账号或密码不能为空！");
      } else {
        var time = new Date()
        var params = {
          type:"1",
          username: this.user,
          password: this.pwd
        }
        var iev = this.IEVersion()
        if(iev==6||iev==7||iev==8||iev==9||iev==10||iev=='edge'){
          params = qs.stringify(params)
        }
        // console.log(params)
        this.$axios
          .post("/login", params)
          .then(function(res) {
            if (res.data.status_code == 3001) {
              alert(res.data.msg);
            } else if (res.data.status_code == 200) {
              console.log(res.data)
              // console.log(that.$store.state.roued)
              that.$store.commit("setusernumber", that.user);
              that.$store.commit("setuserid", res.data.data.user_id);
              that.$store.commit("setusername", res.data.data.name);
              that.$store.commit("setheadimg", res.data.data.head_img);
              that.$store.commit("settimestamp", time.getTime());
              that.$store.commit("settoken", res.data.data.access_token);
              that.$store.commit("setmechanism", res.data.data.customer_name);
              that.$store.commit("setwelcome", 1);
              // console.log(that.$store.state.mechanism)
              // console.log(that.$store.state.iswelcome)
              // console.log(that.$store.state.iswelcome);
              that.$router.push({
                path: that.$store.state.roued
              });
              setTimeout(function() {
                that.$router.go(0);
              }, 50);
            }
          })
          .catch(function(err) {
          console.log(err)
        });
      }
    }
  }
};
</script>

<style scoped lang="scss" type="text/css">
.login {
  width: 100%;
  height: 900px;
  background: url(../../assets/login/background.png) no-repeat center center;
  background-size: 100% 100%;
  position: relative;
  .login_con {
    width: 1060px;
    height: 620px;
    background: url(../../assets/login/login_bg.png) no-repeat center center;
    background-size: 100% 100%;
    /*border: 1px solid red;*/
    position: absolute;
    top: calc(50% - 310px);
    left: calc(50% - 530px);
    .login_rigth {
      width: 340px;
      height: 580px;
      /*border: 1px solid red;*/
      float: right;
      margin-top: 20px;
      margin-right: 20px;
      background: url(../../assets/login/input_bg@2x.png) no-repeat center
        center;
      background-size: 100% 100%;
      .logon_logo {
        width: 70px;
        height: 70px;
        display: block;
        margin: 0 auto;
        margin-top: 80px;
        margin-bottom: 11px;
      }
      .logon_title {
        text-align: center;
        font-size: 17px;
        color: #ead3b6;
        font-family: PingFangSC-Regular, sans-serif;
        font-weight: 500;
        margin-bottom: 50px;
      }
      .login_user {
        display: block;
        width: 288px;
        height: 44px;
        background: #fff;
        border-radius: 22px;
        margin: 0 auto;
        border: none;
        outline: none;
        text-align: center;
        margin-bottom: 20px;
        font-size: 14px;
      }
      .login_btn {
        width: 288px;
        height: 44px;
        line-height: 44px;
        background: url(../../assets/login/login_btn@2x.png) no-repeat center
          center;
        background-size: 100% 100%;
        border-radius: 22px;
        text-align: center;
        color: #fff;
        margin: 0 auto;
        margin-top: 40px;
        cursor: pointer;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/page/login.vue